import { Box, Button } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

const BackButton = () => {
  const navigate = useNavigate();
  const { domain } = useParams();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        width: "100%",
        mb: 3
      }}
    >
      <Button
        startIcon={<ArrowBack />}
        variant="outlined"
        onClick={() => navigate(`/admin/${domain}/admin-landingpage`)}
        sx={{
          width: "100px",
          minWidth: "100px",
          borderRadius: "24px",
          textTransform: "none"
        }}
      >
        Back
      </Button>
    </Box>
  );
};

export default BackButton;